const RequestStatus = {
  IDLE: Symbol('idle'),
  LOADING: Symbol('loading'),
  SUCCEEDED: Symbol('succeeded'),
  FAILED: Symbol('failed'),
};

export default RequestStatus;
